import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';

const ListTaskPage = loadable(() => import('./ListTaskPage'), {
  fallback: <Loader />
});
const AddTaskPage = loadable(() => import('./AddTaskPage'), {
  fallback: <Loader />
});
const EditTaskPage = loadable(() => import('./EditTaskPage'), {
  fallback: <Loader />
});
const ViewTaskPage = loadable(() => import('./ViewTaskPage'), {
  fallback: <Loader />
});

// Socket
import { io } from 'socket.io-client';
const socketURL = process.env.MIX_COMMON_SOCKET_URL ?? 'https://technource.co.in:3003';
const socket = io(socketURL, {
  transports: ['websocket', 'polling'], // Optional: ensure WebSocket is used
  secure: true, // Optional: ensure SSL/TLS
  query: {
    t: Date.now()
  }
});

const TaskRoutes = ({ t, setTabLoading , alert }) => {
  return [
    <Route
      key={'tasK_view'}
      exact
      path="/view/:projectId/task"
      element={<ListTaskPage t={t} socket={socket} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key={'tasK_add'}
      exact
      path="/view/:projectId/task/add"
      element={<AddTaskPage t={t} socket={socket} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key={'tasK_edit'}
      exact
      path="/view/:projectId/task/:projectTaskId/edit"
      element={<EditTaskPage t={t} socket={socket} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key={'tasK_details'}
      exact
      path="/view/:projectId/task/:projectTaskId"
      element={<ViewTaskPage t={t} socket={socket} setTabLoading={setTabLoading} alert={alert} />}
    />
  ];
};
TaskRoutes.propTypes = {};
export default TaskRoutes;
